import { HTMLAttributes, useEffect, useRef } from "react";
import * as echarts from "echarts";
import clsx from "clsx";

type ChartProps = HTMLAttributes<HTMLDivElement> & {
  options: echarts.EChartsOption;
};

export const Chart = ({ options, className }: ChartProps) => {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    let chart: echarts.ECharts;

    if (ref.current) {
      setTimeout(() => {
        chart = echarts.getInstanceByDom(ref.current!) || echarts.init(ref.current)

        chart.setOption(options);
      }, 1)
    }

    const resizeEventListener = () => {
      if (ref.current) {
        const { width } = ref.current.parentElement!.getBoundingClientRect()
        const { height } = ref.current.getBoundingClientRect()

        chart.resize({ width, height });
      }
    }

    window.addEventListener("resize", resizeEventListener)

    return () => {
      window.removeEventListener("resize", resizeEventListener)
    }
  }, [options]);

  return (
    <div ref={ref} className={clsx("h-[200px] w-full border rounded-lg", className)}></div>
  );
};
